import clientConfigApi from '../config/config'
import { extendStayServiceID } from '../config/constant'
import { wipeGuestData } from '../JS/wipeGuestData'

export const guestBillDetails = (selectedGuest, callbackBillDetails, callbackViewBill) => {
    console.log("ABC --- selectedGuest",selectedGuest)
    return dispatch => {
        try {
            clientConfigApi.post(
                "/guestBillDetails/fetch",
                {
                    "header":
                    {
                        "locationId": selectedGuest.location,
                        "guestToken": selectedGuest.guestToken,
                        "reservationNumber": selectedGuest.reservationNumber
                    },
                    "payload": {}
                }
            )
                .then((res) => {
                    console.log("ABC --- guestBillDetails", res);
                    if(res.data.payload.XC){
                        console.log('found XC value')
                        callbackBillDetails(res.data.payload.XC.Status, true, res.data.payload.XC.msg);
                    } else {
                        console.log('does not found XC value')
                        callbackBillDetails('', true);
                    }

                    if(callbackViewBill && res && res.data &&  res.data.header && res.data.header.status && Object(res.data.header.status).hasOwnProperty("billFetched") && res.data.header.status.billFetched == false){
                        throw new Error();
                    }

                    if (res.data && res.data.payload && res.data.payload.billItems &&
                        res.data.payload.billTotal && res.data.payload.billTotal.balanceAmount) {
                            console.log('View Bill give response')
                        dispatch({
                            type: 'View_Bill_Details',
                            payload: {
                                billItems: res.data.payload.billItems,
                                billTotal: res.data.payload.billTotal.balanceAmount,
                                billForGuest: true
                            }
                        })

                    } else {
                        console.log("payload is empty");
                        dispatch({
                            type: 'View_Bill_Details',
                            payload: {
                                billItems: [],
                                billTotal: null,
                                billForGuest: true
                            }
                        })
                    }

                    if(callbackViewBill) callbackViewBill();
                })
                .catch((res) => {
                    if(res.status == 401){
                        wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                    }
                    console.log('Error in viewbill response', res)
                    if(res.response && res.response.data && res.response.data.header && res.response.data.header.status){
                        callbackBillDetails('', false, res.response.data.header.status.msg);
                    } else {
                        callbackBillDetails('', false);
                    }

                    console.log("guestBillDetails/fetch Api fail with status:", res)
                    if(window.FireBasePlugin){
                        window.FirebasePlugin.logError("guestBillDetails/fetch Api fail with status: " + res)
                      }
                })
        } catch (e) {
            console.log("error in Code.");
            callbackBillDetails('', false);
            if(window.FireBasePlugin){
                window.FirebasePlugin.logError("guestBillDetails/fetch : " + e)
              }
        }
    }
}

export const setDefaultBill = (selectedGuest) => {
    return {
        type: 'View_Bill_Details',
        payload: {
            billItems: [],
            billTotal: null,
            billForGuest: false
        }
    }
}

export const extendStay = (selectedGuest, extendStayID, onSuccess, onFailure) => {
    return dispatch => {
        try {
            clientConfigApi.post(
                "/qualityPlus/request",
                {
                    "header": {
                        "locationId": selectedGuest.location,
                        "guestToken": selectedGuest.guestToken,
                        "loggedinGuestToken": selectedGuest.guestToken
                    },
                    "payload": {
                        "reservationNumber": selectedGuest.reservationNumber,
                        "qualityPlusRequest": [
                            {
                                "serviceRequestId": extendStayID,
                                "additionalNote": "",
                                "quantity": 1
                            }
                        ],
                        "sourceApp": "guestJourneyApp",
                        "platform": window.device ? window.device.platform : "Web"
                    }
                }
            )
                .then((res) => {
                    console.log("extend stay res", res);
                    onSuccess("Successfully request your extend stay request.");
                })
                .catch((error) => {
                    console.log("extend stay API fail", error);
                    onFailure("can't process your request. Please try again.");
                }
                )
        } catch (e) {
            console.log("error in extend stay API", e);
            if(window.FireBasePlugin){
                // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
                window.FirebasePlugin.logError("error in extend stay API " + e)
              }
        }
    }
}

export const checkOut = (selectedGuest, total, onSuccess, onFailure) => {
    return dispatch => {
        try {
            clientConfigApi.post(
                "/sendCheckOut/send",
                {
                    "header": {
                        "locationId": selectedGuest.location,
                        "guestToken": selectedGuest.guestToken,
                        "loggedinGuestToken": selectedGuest.guestToken,
                        "reservationNumber": selectedGuest.reservationNumber,
                        "balanceAmount": total
                    },
                    "payload": {
                        "sourceApp": "guestJourneyApp",
                        "platform": window.device ? window.device.platform : "Web"
                    }
                }
            ).then((res) => {
                console.log("extend stay res", res.data);
                if (res.data.header.status.code === "SUCCESS") {
                    onSuccess("Successfully requested your checkOut.");
                } else if (res.data.header.status.code === "FAILED") {
                    onFailure(res.data.header.status.msg || "");
                }
            })
                .catch((response = {}) => {
                      console.log("catch bock executed", response);
                    console.log("extend stay API fail", response.status);
                    if(response.status == 401){
                        wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                    }

                    if(response.response && response.response.data && response.response.data.header && response.response.data.header.status){
                        onFailure(response.response.data.header.status.msg);
                    } else {
                        onFailure("");
                    }
                })
        } catch (e) {
            console.log("error in extend stay API", e);
            onFailure("");
            if(window.FireBasePlugin){
                // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
                window.FirebasePlugin.logError("Checkout Api failed with the status code: " + e)
              }
        }
    }
}

export const getServiceID = (sessionToken, callback) => {
    // This is API to get the service ID of "EXTEND MY STAY" guest request.
    // so that in case if we want to extend stay we can call this request.
    return dispatch => {
        try {
            clientConfigApi.post(
                "/qualityPlus/getGuestRequestDetails",
                {
                    "header": {
                        "sessionToken": sessionToken
                    },
                    "payload": {}
                }
            ).then((res) => {

                console.log("getServiceID", res.data.payload.guestRequestDetails["EXTEND MY STAY"]);
                //onSuccess("Successfully requested your checkOut.");
                if (res.data && res.data.payload && res.data.payload.guestRequestDetails) {
                    dispatch({
                        type: 'Get_Service_ID',
                        payload: res.data.payload.guestRequestDetails["EXTEND MY STAY"] ? res.data.payload.guestRequestDetails["EXTEND MY STAY"].id : null
                    })
                }
                callback(true)
            })
                .catch((error) => {
                    console.log("extend stay API fail", error);
                    callback(false, "Failed to get the data")
                    //onFailure("can't process your request. Please try again.");
                })
        } catch (e) {
            console.log("error in getServiceID API", e);
        }
    }
}

export const guestHistroy = (selectedGuest, callBack) => {
    console.log("selectedGuest", selectedGuest);
    return dispatch => {
        try {
            clientConfigApi.post(
                "/guestHistory/fetch",
                {
                    "header": {
                        "locationId": selectedGuest.location,
                        "guestToken": selectedGuest.guestToken,
                        "loggedinGuestToken": selectedGuest.guestToken,
                        "reservationNumber": selectedGuest.reservationNumber,
                    },
                    "payload": {}
                }
            ).then((res) => {
                console.log("res @@@@", res);
                if (res.data && res.data.header && res.data.header.status
                    && res.data.header.status.code === "SUCCESS") {
                    callBack(true);
                }
            })
                .catch(( response = {}) => {
                    console.log("API guestHistory Failed", response.status);
                    if(response.status == 401){
                        wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                    }
                    //onFailure("can't process your request. Please try again.");
                    callBack(false);
                })
        } catch (e) {
            console.log("error in getServiceID API", e);
        }
    }
}